import React from 'react';

interface MobileFooterProps {
  onShowMobileSidebar: (section: 'about' | 'sources') => void;
  t: any;
}

const MobileFooter: React.FC<MobileFooterProps> = ({ onShowMobileSidebar, t }) => {
  return (
    <div className="lg:hidden border-t border-gray-100 bg-gray-50/50 px-3 py-1 flex-shrink-0">
      <div className="flex items-center justify-center space-x-4 md:space-x-6 text-xs">
        <button
          onClick={() => onShowMobileSidebar('about')}
          className="text-gray-500 hover:text-gray-700 flex items-center space-x-1 transition-colors min-h-[28px] md:min-h-[32px] px-1 md:px-2"
        >
          <span>ℹ️</span>
          <span>About</span>
        </button>
        <button
          onClick={() => onShowMobileSidebar('sources')}
          className="text-gray-500 hover:text-gray-700 flex items-center space-x-1 transition-colors min-h-[28px] md:min-h-[32px] px-1 md:px-2"
        >
          <span>🔗</span>
          <span>Sources</span>
        </button>
      </div>
    </div>
  );
};

export default MobileFooter;